import { Buttons } from "../../../generic-sprites/Buttons"
import { Sprites } from "../../../utils/Sprites"
import { TmSprite } from "../TimeMachineAssets"

const flash = "flash"

export class CloseButton {
    button: Phaser.Sprite

    constructor(game: Phaser.Game, x: number, y: number, group?: Phaser.Group) {
        this.button = Sprites.add(game, TmSprite.CLOSE_BUTTON, {x, y, group})
        this.button.animations.add(flash, [0, 1], 6)
    }

    addOnClick = (onClick: () => void) => {
        Buttons.makeSpriteButton(this.button, () => {
            onClick()
        })
    }

    enable = () => {
        this.flash()
    }

    flash = () => this.button.animations.play(flash, undefined, true)
}
